const TOKEN_COOKIE_NAME = 'PharmaAiToken'

const SSO_LOGIN_URL = {
  test: 'https://apphub.fosunpharma.com:58443/idp/oauth2/authorize?client_id=pharmaidweb&response_type=code&redirect_uri=https://pharmaid-uat.fosunpharma.com/ui-ai-web/oauthStation',
  prod: 'https://bam.fosunpharma.com/idp/oauth2/authorize?client_id=pharmaid&response_type=code&redirect_uri=https://pharmaid.fosunpharma.com/ui-ai-web/oauthStation'
}

/** 测试/演示域名：不强制走 SSO（含 yousui 子域） */
const SSO_BYPASS_HOSTS = new Set([
  'pharmaid-device.yousui.tech',
])

let redirecting = false

function getCookie(name) {
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}

function getSsoLoginUrl() {
  const host = window.location.hostname
  const isProd = host === 'pharmaid.fosunpharma.com'
  return isProd ? SSO_LOGIN_URL.prod : SSO_LOGIN_URL.test
}

export function shouldBypassSso() {
  const host = String(window.location.hostname || '').toLowerCase()
  if (!host) return false
  if (SSO_BYPASS_HOSTS.has(host)) return true
  // 兜底：任意 yousui.tech 子域都跳过 SSO
  return host === 'yousui.tech' || host.endsWith('.yousui.tech')
}

export function getPharmaAiToken() {
  return getCookie(TOKEN_COOKIE_NAME)
}

export function redirectToSso() {
  if (shouldBypassSso()) return false
  if (redirecting) return true

  redirecting = true
  window.location.replace(getSsoLoginUrl())
  return true
}
